import * as React from 'react';

function SvgEmpty(props) {
  return (
    <svg viewBox="0 0 78 104" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#EDEDED"
          d="M1 79.852l11-9.485V34.678l-11 10zm64-45.174l10 10v36.975L65 71.067z"
        />
        <path
          d="M12 34.678h9.514a5 5 0 015 5v4.86H50.19v-4.86a5 5 0 015-5H65v37a5 5 0 01-5 5H17a5 5 0 01-5-5v-37zm1 1v36a4 4 0 004 4h43a4 4 0 004-4v-36h-8.81a4 4 0 00-4 4v5.86H25.514v-5.86a4 4 0 00-4-4H13z"
          fill="#E7E7E7"
          fillRule="nonzero"
        />
        <path
          d="M13 35.678v36a4 4 0 004 4h43a4 4 0 004-4v-36h-8.81a4 4 0 00-4 4v5.86H25.514v-5.86a4 4 0 00-4-4H13z"
          fill="#F8F8F6"
          fillRule="nonzero"
        />
        <path
          d="M2.487 44.678h13.778a5 5 0 015 5v4.86h33.057v-4.86a5 5 0 015-5h14.264l-9-9H55.19a4 4 0 00-4 4v5.86H25.514v-5.86a4 4 0 00-4-4h-9.127l-9.9 9zM75 63.165v18.513a5 5 0 01-5 5H6a5 5 0 01-5-5v-37l11-10h9.514a5 5 0 015 5v4.86H50.19v-4.86a5 5 0 015-5H65l10 10v18.487zM2 45.678v36a4 4 0 004 4h64a4 4 0 004-4v-36H59.322a4 4 0 00-4 4v5.86H20.265v-5.86a4 4 0 00-4-4H2z"
          fill="#E7E7E7"
          fillRule="nonzero"
        />
        <path
          d="M2 45.678v36a4 4 0 004 4h64a4 4 0 004-4v-36H59.322a4 4 0 00-4 4v5.86H20.265v-5.86a4 4 0 00-4-4H2z"
          fill="#F9F9F9"
          fillRule="nonzero"
        />
        <path
          d="M57.63 6.703l.935.354-6.422 16.935-.935-.354L57.63 6.703zm19.321 7.964l.49.872-18.684 10.49-.49-.873 18.684-10.49zM.301 8.278l.807-.59 11.99 16.39-.806.59L.302 8.279zm22.672-7.2l.954-.3 5.1 16.227-.954.3-5.1-16.227z"
          fill="#E7E7E7"
          fillRule="nonzero"
        />
        <ellipse fill="#F8F8F6" cx={39.5} cy={101.678} rx={29.5} ry={2} />
      </g>
    </svg>
  );
}

export default SvgEmpty;
